import React, { useEffect, useState, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { savebooking } from "../../services/wms/grabconcept";
import Imageprofile from "../../components/wms/rederimageprofile";
import Input from "./../wms/input";
import FontAwesome from "react-fontawesome";
import ImageSelected from "../../components/wms/imageselected";
import {UploadFaceImage,ConfirmData,GetRegisterface} from "../../services/wms";
import BranchContext from "./../context/branch";
// import Modaluploadpic from "../../components/wms/modaluploadpic";
const Modelupload = ({
  isOpen,
  header,
  onCancel,
  listcall,onConfirm,
  // error,
  size = "sl",
  reload,
}) => {
  let Daterec = moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD HH:mm");
  const [openUpload, setopenUpload] = useState(false);
  const [cardid, setcardid] = useState("");
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [error, seterror] = useState("");
  
  const { currentBranch } = useContext(BranchContext);
  const [messagerror, setmessagerror] = useState({
    card: "",
    fname: "",
    lname: "",address:"",phone: ""
  });
  const [photos, setphotos] = useState([]);
  const notifyPhotoSelector = (files) => {
    // console.log(files);
    setphotos(files);
  };
  const [imageurl, setImageurl] = useState(
    "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=avartar"
  );
  // const handlesavecall = (even1, even2) => {
  //   doSubmit(even1, even2);
  // };
  useEffect(() => {
    setfname(listcall[1])
    setcardid(listcall[0])
   
  }, [listcall]);
  const handleImageClick = (e) => {
    if (cardid === "" ) {
      seterror("เลขบัตรไม่ครบถ้วน\nกรุณาระบุก่อนค่ะ");
      return;
    }
    if (fname === "" ||  fname == "-") {
      seterror("ชื่อ-สกุล\nกรุณาระบุก่อนค่ะ");
      return;
    }
    setopenUpload(true);
  };
  const confirmsave = () => {
    doSubmit();
     //onConfirm();
  };
  const handleCancleUpload = () => {
    setopenUpload(false);
  };
  const handelCardChange = (event) => {
    setcardid(event.currentTarget.value);
  };
  const handelFnameChange = (event) => {
    setfname(event.currentTarget.value);
  };
  const handellnameChange = (event) => {
    setlname(event.currentTarget.value);
  };
  const doSubmit = async () => {
    if (cardid === "" ) {
      seterror("เลขบัตรไม่ครบถ้วน\nกรุณาระบุก่อนค่ะ");
      return;
    }
    if (fname === "" ||  fname == "-") {
      seterror("ชื่อ\nกรุณาระบุก่อนค่ะ");
      return;
    }
    const getPhoto = photos.find((x) => x);  
    let photoBase64 = "";
    try {
      photoBase64 = getPhoto ? await getPhoto.getFileEncodeDataURL() : "";
    } catch (err) {
      //console.log('Error',err);
    }
    if (!photoBase64) return toast.error("ไม่พบข้อมูลรูปภาพ");
    if (photoBase64.includes("data:image/png;base64,"))
      photoBase64 = photoBase64.replace("data:image/png;base64,", "");
    if (photoBase64.includes("data:image/jpg;base64,"))
      photoBase64 = photoBase64.replace("data:image/jpg;base64,", "");
    if (photoBase64.includes("data:image/jpeg;base64,"))
      photoBase64 = photoBase64.replace("data:image/jpeg;base64,", "");

const name =fname.split(" ")
    const doc = { IdentityID: cardid,FName : name[0],Lname : name[1],ProfileAddress : "-",Telephone : "-",SexID : "1",BirthDate : "1990-01-01", ImageData : photoBase64, appcode: "React" };
//console.log("doc",doc)
    const { data: result } = await UploadFaceImage(doc);
    if (result.status === "success") {
      const docdata = { IdentityID: cardid,Code : "1",BranchID : currentBranch._id};
      const { data: result } = await ConfirmData(docdata);
      if (result.status === "success") {
        toast.success("upload เสร็จเรียบร้อย");
        onCancel(false)
      }else{
        toast.error(result.message);
      }
    } else {
      toast.error(result.message);
    }
  };
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
        <FontAwesome name="pencil-square-o"> </FontAwesome> {header}UPload รูปภาพ

          
        </ModalHeader>
        <ModalBody>
        {listcall && listcall.length > 0 &&
        <div className="card text-center border-secondary  ">
              <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-warning">
                <FontAwesome name="user"> </FontAwesome> ข้อมูลพนักงานขับรถ
              </div>
              <div className="card-body">
                <div className="row">            
                  <div className="col-sm-6 col-xs-12">
                  <Input
                      name="name"
                      value={fname}
                      label="ชื่อ"
                      placeholder="ระบุชื่อ"
                      onChange={handelFnameChange}             
                      // error={messagerror.fname}
                    />                
                  </div>
                  {/* <div className="col-sm-6 col-xs-12">
                  <Input
                      name="lname"
                      value={lname}
                      label="สกุล"
                      placeholder="ระบุสกุล"
                      onChange={handellnameChange}
                      // error={messagerror.lname}
                    />               
                  </div> */}
                  <div className="col-sm-6 col-xs-12">
                    <Input
                      name="cardid"
                      value={cardid}
                      label="เลขที่บัตร"
                      placeholder="เลขที่บัตร"
                      onChange={handelCardChange}
                      
                      //error={messagerror.card}
                    />              
                  </div>
                  <div className="col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div className="col-auto text-center text-center">
                    
                      {/* <button
                          type="button"
                          className="btn"
                          aria-label="เปลี่ยนรูปโปรไฟล์"
                          onClick={(e) => handleImageClick(e)}
                        >
                          <Imageprofile imageurl={imageurl} />
                        </button> */}
                        {/* <p>คลิกรูป</p> */}
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div className="row">            
                  <div className="col-sm-12 col-xs-12">

                  <ImageSelected notifyFileUpload={notifyPhotoSelector} />
                  </div>
                  <div className="col-md-12 alert alert-warning"> ควรเป็นรูปครึ่งตัว และพื้นหลังสีขาว ไม่เกิน 2M</div>
                  </div>
                
              </div>
            </div>
                    
                      }
          </ModalBody>
        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}

        <ModalFooter>
          {listcall && <div className="col-lg-4  col-sm-6 col-xs-12"> </div>}

          {listcall && (
           <Button color="primary" onClick={confirmsave}>
           บันทึก
         </Button>
          )}
          <Button 
          color="secondary" onClick={onCancel}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modelupload;
